import firebase from '@/firebase.config'
import Vue from 'vue'
import firestore from './firestore.js'

export default {
  state: () => ({
      // Store a firebase ref for the lecturer to easily add to subcollections
      lecturerRef: null
  }),
  getters: {
    lecturer(state, getters, rootState) {
      // Lecturer may not have loaded yet
      let lecturer = {}
      if (rootState.firestore.dbRoot.lecturers) {
        if (rootState.firestore.dbRoot.lecturers.length > 1) {
          throw 'Too many lecturers in Vuex: ' + rootState.firestore.dbRoot.lecturers.length
        }
        lecturer = rootState.firestore.dbRoot.lecturers[0]
      } 
      return lecturer
    },
    lecturerRef(state) {
      return state.lecturerRef
    }
  },
  mutations: {
    SET_LECTURER_REF(state, lecturerRef) {
      state.lecturerRef = lecturerRef
    }
  },
  actions: {
    // LECTURER ACTIONS
    async bindLecturerData({ commit, getters }) {
      // Only allow this binding to be created once
      if (!getters.singletonGuards.includes('LECTURER_BIND')) {
        commit('ADD_SINGLETON_GUARD', 'LECTURER_BIND')

        commit('ADD_ROOT_TO_DIRECTORY')
        const lecturerRef = firebase.firestore().collection('lecturers').doc(getters.user.id)
        // Store lecturerRef for future use
        commit('SET_LECTURER_REF', lecturerRef)
        // Bind lecturer and their subcollections
        await firestore.bindFirestoreRef(commit, lecturerRef)
        await firestore.bindFirestoreRef(commit, lecturerRef.collection('subjects'))
        await firestore.bindFirestoreRef(commit, lecturerRef.collection('tutorials'))
        await firestore.bindFirestoreRef(commit, lecturerRef.collection('teachingSessions'))

        // Subscribe to listen for new attempts being added 
        // Fetch student object for each new attempt
        this.subscribe(async ( mutation ) => {
          if (mutation.type === 'ADD_DOC' && mutation.payload.ref.parent.id === 'attempts'){
            // Lookup the object in the directory
            let doc = getters.directory[mutation.payload.ref.path]

            // Check if the user object for the student has already been loaded
            try {
              doc.student.data
            } catch (err) {
              if (err instanceof TypeError) {
                const user = await getters.db.collection('users').doc(doc.data.studentId).get()
                let userDoc = firestore.doc2data(user)
                // add reference to user to the attempt
                Vue.set(doc, 'student', userDoc)
              } 
              else {
                throw err
              }
            }
          }
        })
        // Now that listener is subscibed bind the attempts
        await firestore.bindFirestoreRef(commit, lecturerRef.collection('attempts'))
      }
    },
    async addLecturer({ getters }, {userId, lecturerData}) {
      await getters.db.collection('lecturers').doc(userId).set(lecturerData)
    },
    async updateLecturer({ getters }, lecturer) {
      await getters.db.doc(lecturer.path).set(lecturer.data)
    },
    async addSubject({ getters }, subjectData) {
      await getters.lecturerRef.collection('subjects').add(subjectData)
    },
    async updateSubject({ getters }, subject) {
      await getters.db.doc(subject.path).set(subject.data)
    },
    async addTutorial({ getters }, tutorialData) {
      await getters.lecturerRef.collection('tutorials').add(tutorialData)
    },
    async updateTutorial({ getters }, tutorial) {
      await getters.db.doc(tutorial.path).set(tutorial.data)
    },
    async addTeachingSession({ getters }, teachingSessionData) {
      await getters.lecturerRef.collection('teachingSessions').add(teachingSessionData)
    },
    async updateTeachingSession({ getters }, teachingSession) {
      await getters.db.doc(teachingSession.path).set(teachingSession.data)
    },
  }
}
